module.exports = __webpack_public_path__ + "img/stamp-fish-winter.7415b659.png";